
import { useAgentActionsMenu } from '@/components/agents-table/AgentActionsMenu.helpers';
import { defineComponent, inject, PropType, ref, VNodeRef } from 'vue';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { SelectedAgent } from './AgentActionMenu.types';

export default defineComponent({
  props: {
    agents: {
      type: Array as PropType<SelectedAgent[]>,
      required: true,
    },
  },
  setup() {
    const IcmMenuRef = ref<VNodeRef>();
    const platformAuthentication = inject(IKPlatformAuthentication);
    const agentsActions = useAgentActionsMenu(platformAuthentication?.osType.value || OsType.Windows, IcmMenuRef);
    return { agentsActions };
  },
});
